import { z } from 'zod';

import type { MessageKey } from '@/modules/localizations/translations/types';

export const apiKeyFormSchema = z.object({
    name: z
        .string()
        .min(1, { message: 'api-keys.create.name.required' satisfies MessageKey })
        .max(100, { message: 'api-keys.create.name.maxLength' satisfies MessageKey }),
});

export type ApiKeyFormSchema = typeof apiKeyFormSchema;

export type ApiKeyFormValues = z.infer<typeof apiKeyFormSchema>;
